<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <BacktoPage path="/Masters"></BacktoPage>
          <Headerlayout :headertext="$t('Pharmacy.GenericMaster.List')"
            :contenttext="$t('Pharmacy.GenericMaster.TableHeaderContent')">
          </Headerlayout>
        </b-col>
      </b-row>
      <b-row class="py-3">

        <div v-if="windowWidth > 545">
          <SkeletonTableLoader :columns="headers" :loading="loading" />
          <div v-if="!loading">
            <MasterEmpty v-if="List.length === 0 && !loading" eheader="Generic Master" econtent="Generic Master"
              eimg="/src/assets/Img/icons/genericmaster.svg" @createNew="IsAdd" />
            <Tableview v-if="List.length !== 0" :value="List" :paginator="true" class="p-datatable-gridlines" :rows="10"
              dataKey="Id" :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll"
              :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters" selectionMode="single"
              @row-click="RowClick" :exceldownload="true">
              <template v-slot:Add>
                <span class="add">
                  <AddButton :btnname="$t('btn.plusaddnew')" class="float-rights my-3" @click="IsAdd()" />
                </span>
              </template>

              <template v-slot:exceldownload>
                <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                  PageName="Generic Master" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
              </template>
              <template v-slot:Status="{ data }">

                <OrangeStatus name="InActive" v-if="data.IsActive == '0'" />
                <GreenStatus name="Active" v-if="data.IsActive == '1'" />
              </template>
              <template v-slot:action="{ data }">
                <span>


                  <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                    @click="toggle($event, data)" />
                </span>
              </template>
            </Tableview>
          </div>
        </div>
        <div v-if="windowWidth <= 545">
          <MobileLoader v-if="loading" v-for="item in 5" />
          <div v-if="!loading">
            <MasterEmpty v-if="List.length === 0 && !loading" eheader="Generic Master" econtent="Generic Master"
              eimg="/src/assets/Img/icons/genericmaster.svg" @createNew="IsAdd" />
            <MobileViewCardHeader>
              <template v-slot:mobilecard>
                <div class="mobile-card" v-for="item in List">
                  <div class="d-flex align-items-center justify-content-between gap-2">
                    <div>
                      <p class="light-name">{{ item.GenericCode }}</p>
                      <p class="name">{{ item.GenericName }}</p>
                    </div>
                    <div class="d-flex align-items-center">
                      <div>

                        <OrangeStatus name="InActive" v-if="item.IsActive == '0'" />
                        <GreenStatus name="Active" v-if="item.IsActive == '1'" />
                      </div>
                      <i class="pi pi-ellipsis-v" @click="toggle($event, item)"></i>
                    </div>
                  </div>
                  <div class="d-flex align-items-center gap-2">
                    <p class="light-name">Items :</p>
                    <p class="small-name">{{ item.GenericItems }}</p>
                  </div>
                </div>
              </template>
            </MobileViewCardHeader>

          </div>
        </div>
        <GenericModal v-model:trigger="showDialog" v-if="showDialog" v-model:selected-item="editItems"
          @load="IsShow(), (showDialog = false)" @close="showDialog = false" @loaderhide="loading = false"
          @loadershow="loading = true" :OperationID="ObjOperationId" :EntityId="EntityData.EntityId" />
      </b-row>


      <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
      <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
        :content="$t('confirmation.editcontent')" />
      <DeleteConfirmationVue :DeleteModel="Deletemodel" :content="content" @yes="IsDelete(dataEdit)"
        @no="Deletemodel = false" />
      <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
      <ActivatedSuccessfully :visible="popup.activatepop" @ok="closetrigger()" />
      <InActivatedSuccessfully :visible="popup.inactivepop" @ok="closetrigger()" />
      <Mapping :content="contentName" :visible="MappingPopUp" @ok="closeMapping()" />

    </b-container>
  </div>
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, h, onMounted, onUnmounted } from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import GenericModal from "../../../../pages/Masters/Pharmacy/GenericMaster/GenericMasterCreation.vue";
import GenericService from "../../../../Service/GenericMasterService";
import FilterSidebar from "../../../Masters/Pharmacy/GenericMaster/GenericmasterFilter.vue";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import { FilterMatchMode, FilterOperator } from "primevue/api";
import DeleteIcon from "../../../../../../components/GeneralButtons/DeleteIcon.vue";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import Mapping from "../../../../../../components/FormComponents/Mapping.vue";
import MobileView from "../../../../../../modules/Inventory/pages/Masters/Pharmacy/GenericMaster/GenericMasterMobileViewCard.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import ActivatedSuccessfully from "../../../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../../../components/FormComponents/InActivateSuccessfully.vue";

import MastersService from "../../../../Service/MastersService";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../Service/AccessControl";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";

export default defineComponent({
  components: {
    BacktoPage,
    Headerlayout,
    GenericModal,
    FilterSidebar,
    Tableview,
    DeleteConfirmationVue,
    Loader,
    DeletedSuccessfully,
    EditConfirmation,
    Mapping,
    MobileView,
    MasterEmpty,
    ActivatedSuccessfully,
    InActivatedSuccessfully,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    ExportOption,
  },
  setup() {
    const toast = useToast();
    const generic = ref();
    let loading1 = ref(false);
    const showDialog = ref(false);
    const editItems = ref();
    const Editmodel = ref(false);
    const { t } = useI18n();
    const Deletemodel = ref(false);
    const ActiveInActiveModel = ref(false);
    const rowFocus = ref(false);
    let deletepop = ref(false);
    const dataEdit = ref();
    let contentName = ref("");
    const MappingPopUp = ref(false);
    const ObjData = ref();
    const popup = ref({
      activatepop: false,
      inactivepop: false,
    });
    let content = ref("");
    const menu = ref();
    let InActivevisible = ref(false);
    let Activevisible = ref(false);
    let Editvisible = ref(false);

    let loading = ref(false);

    let List: any = ref([]);
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      GenericCode: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      GenericName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      GenericItems: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      CreatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      Code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      ActiveStatus: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    const headers = [
      {
        header: t('Pharmacy.GenericMaster.sno'),
        field: "RowNumber",
        class: "filterdisplaynone smallwidth",
      },
      {
        header: t('Pharmacy.GenericMaster.Code'),
        field: "GenericCode",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t('Pharmacy.GenericMaster.Name'),
        field: "GenericName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow1",
        class: "mediumwidth",
      },
      {
        header: t('Pharmacy.GenericMaster.Items'),
        field: "GenericItems",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow1",
        class: "mediumwidth",
      },
      {
        header: t('Pharmacy.GenericMaster.Status'),
        field: "ActiveStatus",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor",
        slot: "Status",
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        fieldDisplay: "false",
        class: "filterdisplaynone last-column-position",
      },
    ];
    const globalFilterFields = ref(headers.map((col) => col.field));

    let ExportOption = ref("");
    let ExportList = ref([]);


    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        const response = await GenericService.getlistdata();

        let count = 0;
        response["result"] = response["result"]
          .filter((items) => items.HospitalId == usersData.OrganizationId)
          .map((item) => {
            count = count + 1;
            item.RowNumber = count;
            item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
            return item;
          });


        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log("ContactTable Data", List.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }


    const toggle = (event, data) => {
      debugger;
      ObjData.value = data;
      if (data.IsActive == 1) {
        Activevisible.value = false;
        InActivevisible.value = true;
        Editvisible.value = true;
      } else if (data.IsActive == 0) {
        Activevisible.value = true;
        InActivevisible.value = false;
        Editvisible.value = false;
      }
      menu.value.toggle(event);
    };

    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: Editvisible,
            command: async () => {
              IsConfirmEdit(ObjData);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              IsConfirmDel(ObjData, 0);
            },
          },

          {
            label: "Active",
            icon: "editicon pi pi-check-circle",
            visible: Activevisible,
            command: async () => {
              IsConfirmDel(ObjData, 1);
            },
          },
          {
            label: "InActive",
            icon: "deleteicon pi pi-minus-circle",
            visible: InActivevisible,
            command: async () => {
              IsConfirmDel(ObjData, 2);
            },
          },
        ],
      },
    ]);

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    onMounted(() => {
      window.addEventListener("resize", handleResize);

      document.addEventListener("keydown", onKeyUp);
      FunctionRights();
      IsShow();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });

    async function FunctionRights() {
      debugger;
      const response = await MastersService.CheckMenuRights(
        EntityData.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
    }

    //Add-New Button-Open Popup
    const IsAdd = () => {
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        showDialog.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };

    //TableView
    async function IsShow() {
      loading.value = true;
      debugger;
      try {
        const response = await GenericService.getlistdata();

        let count = 0;
        response["result"] = response["result"]
          .filter((items) => items.HospitalId == usersData.OrganizationId)
          .map((item) => {
            count = count + 1;
            item.RowNumber = count;
            item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
            return item;
          });

        List.value = response["result"];
        console.log(List.value);
        loading.value = false;
      } catch (error) {
        loading.value = false;
        console.log(error);
      }
    }

    function IsConfirmEdit(data) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Edit");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function IsEdit(data) {
      debugger;
      editItems.value = data;
      Editmodel.value = false;
      showDialog.value = true;
    }

    async function IsConfirmDel(data, status) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Delete");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = false;
        Deletemodel.value = true;
        data.ActiveStatus = status;
        if (status == 1) {
          content.value = "Activate";
        } else if (status == 2) {
          content.value = "InActivate";
        } else {
          content.value = t('confirmation.deletecontent');
        }
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function closetrigger() {
      deletepop.value = false;
      popup.value.activatepop = false;
      popup.value.inactivepop = false;
    }

    function closeMapping() {
      debugger;
      MappingPopUp.value = false;
      Deletemodel.value = false;
    }

    async function IsDelete(data) {
      loading.value = true;
      debugger;
      try {
        let result: any = "";
        if (data.ActiveStatus == 0) {
          result = await GenericService.deletedata(data.value.Id);
        } else {
          let status = data.ActiveStatus == 1 ? true : false;
          result = await GenericService.active(data.value.Id, status);
        }
        let message = result["ErrorInfo"].ErrorCode;

        if (result["result"] != "False" && message == null) {
          contentName.value = result["result"];
          loading.value = false;
          MappingPopUp.value = true;
        } else if (message == null) {
          if (data.ActiveStatus == 1) {
            popup.value.activatepop = true;
          } else if (data.ActiveStatus == 2) {
            popup.value.inactivepop = true;
          } else {
            deletepop.value = true;
          }
          Deletemodel.value = false;
          rowFocus.value = false;
          IsShow();
        }
      } catch (error) {
        loading.value = false;
        console.log(error);
      }
    }

    function onKeyUp(event: any) {
      debugger;

      console.log(dataEdit.value);
      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true &&
        Deletemodel.value == false &&
        showDialog.value == false
      ) {
        Editmodel.value = true;
      } else if (
        event.altKey &&
        event.key == "n" &&
        Editmodel.value == false &&
        Deletemodel.value == false
      ) {
        IsAdd();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        IsDelete(dataEdit.value);
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit(dataEdit.value);
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (
        event.key == "d" &&
        rowFocus.value == true &&
        showDialog.value == false &&
        Editmodel.value == false
      ) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      } else if (event.key == "Escape" && MappingPopUp.value == true) {
        MappingPopUp.value = false;
        Deletemodel.value = false;
      }
    }

    function RowClick(event: any) {
      debugger;
      rowFocus.value = true;
    }

    return {
      EntityData,
      closeMapping,
      MappingPopUp,
      contentName,
      headers,
      List,
      loading1,
      filters,
      IsAdd,
      globalFilterFields,
      showDialog: showDialog,
      generic,
      IsShow,
      IsDelete,
      showgenericright: ref(false),
      IsConfirmDel,
      Deletemodel,
      loading,
      closetrigger,
      IsEdit,
      IsConfirmEdit,
      dataEdit,
      editItems,
      Editmodel,
      RowClick,
      deletepop,
      menu,
      toggle,
      itemListed,
      popup,
      content,
      ObjOperationId,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
    };
  },
});
</script>

<style>
.mobile-name {
  color: #444444;
  font-size: 16px;
  font-weight: 600;
}

.mobile-id {
  color: #999999;
  font-size: 14px;
}

.mobile-number {
  color: #999999;
  font-size: 14px;
}
</style>
<style lang="scss" scoped>
.mobilecategoryname {
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-top: -7px;
}

.mobilestorename {
  font-size: 14px;
  color: #999999;
}
</style>
